var _ellipse, _ellipse2, _polyline, _polyline2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "stroke-color-main",
    cx: 81.76,
    cy: 172.438,
    rx: 15.671,
    ry: 15.799
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "stroke-color-main",
    cx: 131.924,
    cy: 172.438,
    rx: 15.639,
    ry: 15.799
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "stroke-color-main",
    points: "56.518 133.144 153.347 133.144 190.523 60.246 33.516 60.246"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "stroke-color-main",
    points: "0.535 11.763 20.361 11.893 65.529 172.567"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 97.904,
    y1: 173.937,
    x2: 116.415,
    y2: 173.937
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.363d040a71668e7dfff87d88918993b6.svg";
export { ForwardRef as ReactComponent };